{
  "title": "إعدادات الحوالات",
  "saved": "تم حفظ الإعدادات بنجاح",
  "meta": "آخر تحديث: {{updatedAt}} بواسطة {{updatedBy}}",
  "fields": {
    "organisationNameAr": "اسم المؤسسة للإيصال (عربي)",
    "organisationNameEn": "اسم المؤسسة للإيصال (إنجليزي)",
    "declarationTextAr": "نص الإقرار (عربي)",
    "declarationTextEn": "نص الإقرار (إنجليزي)",
    "receiptFooterAr": "تذييل الإيصال (عربي)",
    "receiptFooterEn": "تذييل الإيصال (إنجليزي)",
    "sendSenderCopy": "إرسال نسخة للمرسل",
    "phoneVerification": "تأكيد رقم الهاتف برمز واتساب",
    "phoneVerificationHelp": "يرسل رمز عبر واتساب عند إضافة عميل أو تغيير رقم الهاتف. ولا يتم الحفظ إلا بعد إدخال الرمز."
  }
}
